/* global window, document, URL, Blob */

import moment from 'moment';
import * as R from 'ramda';

export default function EditTestDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpDataService,
  bcpSharedModelService,
  editTestDocumentDialog,
  ssDialogService,
  orgDataService
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.hasData = false;
  vm.canEdit = true;
  vm.addButtonClicked = false;
  if (!R.isNil(vm.test.testDate)) {
    vm.testDate = moment(vm.test.testDate);
  }

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleAddTestDocument = _handleAddTestDocument;
  vm.handleEditTestFormSubmit = _handleEditTestFormSubmit;
  vm.handleDownloadDocument = _handleDownloadDocument;

  _initEventListeners();

  function _initEventListeners() {
    $scope.$on('refreshBCPTestDocument', _handleUpdateTestDocuments);
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editTestDialog);
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _saveProgress() {
    vm.test.assessmentId = vm.assessmentId;
    vm.test.testTypeId = vm.test.testType.testTypeId;
    if (!R.isNil(vm.testDate)) {
      vm.test.testDate = moment(vm.testDate).format('MM/DD/YYYY');
    } else {
      vm.test.testDate = null;
    }
    return bcpSharedModelService.saveTest(vm.test);
  }

  function _handleUpdateTestDocuments() {
    bcpDataService.getTestDocuments(vm.test.assessmentTestId).then((testDocumentResponse) => {
      vm.test.testDocuments = testDocumentResponse.data.result;
    });
  }

  function _handleAddTestDocument($event) {
    vm.addButtonClicked = true;
    if ($scope.editTestForm.$valid) {
      _saveProgress().then((response) => {
        alerts.success('The Test was saved successfully.');
        $rootScope.$broadcast('refreshBCPAssessments');
        const test = response.data;
        vm.test.assessmentTestId = test.assessmentTestId;

        ssDialogService.dialogs.bcp.editTestDocumentDialog = ssDialogService.alert(
          editTestDocumentDialog.getOptions($event, {
            assessmentId: vm.assessmentId,
            test,
            testDocument: {
              assessmentTestDocumentId: 0,
            },
          })
        );
        ssDialogService.show(ssDialogService.dialogs.bcp.editTestDocumentDialog);
      });
    }
  }

  function _handleEditTestFormSubmit() {
    if ($scope.editTestForm.$valid) {
      _saveProgress().then(() => {
        alerts.success('The Test was saved successfully.');
        $rootScope.$broadcast('refreshBCPAssessments');
        _closeDialog();
      });
    }
  }

  function _handleDownloadDocument() {
    alerts.info('Please wait. Download is in progress..');
    bcpDataService.downloadTestTemplate().then((downloadDocumentResponse) => {
      if (downloadDocumentResponse.status === 200) {
        orgDataService.downloadDocument(downloadDocumentResponse.data.documentId, vm.customerId)
          .then((byteResponse) => {
            const contentType = byteResponse.headers('Content-Type');
            const contentDisposition = byteResponse.headers('Content-Disposition');
            let downloadName = '';

            const reverseFileName = downloadName.split('').reverse().join('');
            if (reverseFileName.indexOf('.') < 0 && !R.isNil(contentDisposition)) {
              const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
              downloadName = matches && matches.length > 1 ? matches[1] : null;
              downloadName = downloadName.split('"').join('');
            }

            const blob = new Blob(
              [byteResponse.data],
              { type: contentType, }
            );

            // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, downloadName);
            } else {
              const anchor = document.createElement('a');
              document.body.appendChild(anchor);
              anchor.setAttribute('type', 'hidden');

              anchor.href = URL.createObjectURL(blob);
              anchor.download = downloadName;
              anchor.target = '_self';
              anchor.click();
            }
          });
      } else {
        alerts.error('An error occurred while downloading test template.');
      }
    });
  }
}

EditTestDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpDataService',
  'bcpSharedModelService',
  'editTestDocumentDialog',
  'ssDialogService',
  'orgDataService'
];
